module.exports = __webpack_public_path__ + "media/images/icons/outlined/upload-b05aac94a815cb0bee00076d8d06f79a.svg";